/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wrapped_Streak_ZeroInputs */

const en_us2_wrapped_streak_zero = /** @type {(inputs: Wrapped_Streak_ZeroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every streak starts with one week on plan.`)
};

const pt_br2_wrapped_streak_zero = /** @type {(inputs: Wrapped_Streak_ZeroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toda sequência começa com uma semana no plano.`)
};

const es_419_wrapped_streak_zero = /** @type {(inputs: Wrapped_Streak_ZeroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toda racha empieza con una semana cumpliendo el plan.`)
};

const pt_pt2_wrapped_streak_zero = /** @type {(inputs: Wrapped_Streak_ZeroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qualquer sequência começa com uma semana no plano.`)
};

const fr_fr2_wrapped_streak_zero = /** @type {(inputs: Wrapped_Streak_ZeroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toute série commence par une semaine selon le programme.`)
};

const de_de2_wrapped_streak_zero = /** @type {(inputs: Wrapped_Streak_ZeroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jede Serie beginnt mit einer Woche nach Plan.`)
};

const it_it2_wrapped_streak_zero = /** @type {(inputs: Wrapped_Streak_ZeroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ogni striscia inizia con una settimana in regola.`)
};

/**
* | output |
* | --- |
* | "Every streak starts with one week on plan." |
*
* @param {Wrapped_Streak_ZeroInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_streak_zero = /** @type {((inputs?: Wrapped_Streak_ZeroInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Streak_ZeroInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_streak_zero(inputs)
	if (locale === "es-419") return es_419_wrapped_streak_zero(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_streak_zero(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_streak_zero(inputs)
	if (locale === "de-DE") return de_de2_wrapped_streak_zero(inputs)
	if (locale === "it-IT") return it_it2_wrapped_streak_zero(inputs)
	return en_us2_wrapped_streak_zero(inputs)
});
export { wrapped_streak_zero as "wrapped.streak_zero" }